import hash = require("object-hash");
import _ = require("lodash");
import { CellType, ExcelColorValue, UploadStatus, Constants, ColumnType } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { labels, currentResource, getFormattedDate } from "../../util/utils";
import Utility from "../../util/utilityFunctions";

export class AddOSTTaskConfiguration implements IColumnConfig {
  rowheader: any[];
  columns: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: labels.status,
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return `${currentResource.uploadStatusLabels[UploadStatus.Downloaded]}`;
        },
      },
      {
        CellHeader: labels.updateCanvas,
        IsMarkValue: true, // This can be only one
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
        },
        getCellData: (data) => {
          return Constants.MarkForUpdateNo;
        },
        referenceData: {
          getCellData: (data) => {
            return Utility.updateEYCanvasDropDownValues;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.prefix,
        CellId: "Prefix",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.requiredTitle,
        CellId: "RequiredTitle",
        CellFormat: {
          locked: false,
          requiredColumnWidth: 278.27, //50 Width
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.suffix,
        CellId: "Suffix",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.timePhaseRequired,
        CellId: "TimePhaseRequired",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "TimePhaseRequiredreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "C",
          referenceDataCellNameEndAddress: "F",
          referenceDataCellRowStartIndex: 5,
          referenceDataCellRowIndexMax: 1000,
          outputDataattributes: ["value","startDate", "endDate", "id"],
        },
        CellFormat: {
          locked: false,
          requiredColumnWidth: 140.93, //25 Width
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.taskGroupRequired,
        CellId: "TaskGroupRequired",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "TaskGroupRequiredreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "H",
          referenceDataCellNameEndAddress: "J",
          referenceDataCellRowStartIndex: 5,
          referenceDataCellRowIndexMax: 1000,
          outputDataattributes: ["value", "groupName", "id"],
        },
        CellFormat: {
          locked: false,
          requiredColumnWidth: 140.93, //25 Width
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.customizedDescriptionRequired,
        CellId: "CustomizedDescription",
        dataType: "richText",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: currentResource.OstTaskReferenceSheetColumns.tags,
        CellId: "Tags",
        referenceData: {
          sourceDataObjectName: "TagsreferenceData",
          showDynamicDropdown: true,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "L",
          referenceDataCellNameEndAddress: "P",
          referenceDataCellRowStartIndex: 5,
          referenceDataCellRowIndexMax: 1000,
          outputDataattributes: ["value", "tagGroup", "tag", "color", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          return data.controlName;
        },
        CellData: {
          dataAttributeName: "engagementTagName",
          sourceDataAttributeName: "tagsList",
          separator: "; ",
          dataType: "list",
          dataMode: "concatenate",
          cellDataTemplate: "",
      }
      },
      {
        CellHeader: labels.picSignOffRequired,
        CellId: "PicSignOffRequired",
        cellToBindDropDown: true,
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.YesNoTypes : currentResource.YesNoTypes;
          },
        },
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.eqrSignOffRequired,
        CellId: "EqrSignOffRequired",
        cellToBindDropDown: true,
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.YesNoTypes : currentResource.YesNoTypes;
          },
        },
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.taskId,
        CellId: "TaskId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return data.controlName;
        },
      },
      {
        CellHeader: labels.hash,
        CellId: "HashValue",
        HashAttribue: {
          HashCalculatedDataattributesName: [
            {
              CellId: "Prefix",
            },
            {
              CellId: "RequiredTitle",
            },
            {
              CellId: "Suffix",
            },
            {
              CellId: "TimePhaseRequired",
            },
            {
              CellId: "TaskGroupRequired",
            },
            {
              CellId: "CustomizedDescription",
            },
            {
              CellId: "Tags",
            },
            {
              CellId: "PicSignOffRequired",
            },
            {
              CellId: "EqrSignOffRequired",
            },
          ],
        },
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          let hashValue: string = "";
          hashValue = Utility.getHashValueForRow(this.columns, [], data); // can be more then one
          return hashValue;
        },
      },
      {
        CellHeader: labels.statusId,
        CellType: CellType.DynamicCell,
        CellId: "UploadStatusId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return `${UploadStatus.Downloaded}`;
        },
      },
    ];
    this.rowheader = [
      {
        CellHeader: labels.referenceOnly,
        DisplayRange: ["A1:A1", "L1:N1"],
        CellFormat: {
          locked: true,
        },
      },
      {
        CellHeader: labels.columnsToUpdate,
        DisplayRange: ["B1:K1"],
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.GrayColor,
        },
      },
    ];
  }
}
